import React, { PureComponent } from 'react'
import { Radium } from 'higher-order-components'
import PropTypes from 'prop-types'
import { VideoBackground } from 'components'
import { RoundIconButton } from 'containers'
import { scrollToElementId } from 'utils'

class VideoWithTimedFrames extends PureComponent {
  constructor() {
    super()
    this.state = {
      currentFrameIndex: -1,
      videoWidth: 1,
      videoHeight: 1,
      widthParent: 1,
      heightParent: 1
    }
  }
  updateCurrentFrame = (videoElement) => {
    const currentTime = videoElement.currentTime
    if (currentTime) {
      // Find frame with time greater than current time but less than next frame time
      const currentFrameIndex = this.props.frames.findIndex(({ startTime, endTime }) => currentTime > startTime && currentTime < endTime)
      // // Set frame as current (no special exceptions for -1)
      this.setState({ currentFrameIndex })
    }
  }
  initialiseVideo = ({ target }) => {
    // Check all frames are valid (set for a time less than the duration of the video)
    if (this.props.frames.some(({ time }) => time >= target.duration)) {
      console.warn('Some of the frames provided are set to display after the video ends')
    }
  }
  getDimensionsChild = (entry) => {
    this.setState({
      videoWidth: entry.width,
      videoHeight: entry.height
    })
  }
  render() {
    const { currentFrameIndex } = this.state

    // Set frame variable to currentFrames components (if no frame was found render null)
    const frame = currentFrameIndex > -1 ? this.props.frames[currentFrameIndex] : null
    const components = frame && frame.components ? frame.components : null
    const scale = Math.min(
      this.state.videoWidth / 1000,
      this.state.videoHeight / 1000
    )
    const frameStyle = frame && frame.resizable ? {
      transform: `translate(-50%, -50%) scale(${scale})`,
      position: 'absolute',
      width: `${this.state.videoWidth / scale}px`,
      height: '100%',
      left: '50%',
      top: '50%'
    } : {
        height: '100%'
      }

    const {
      scrollToSlug
    } = this.props
    return (
      <div style={[this.props.styles, { position: 'relative' }]}>
        <div
          style={frameStyle}>
          {components}
        </div>
        <VideoBackground
          onLoadedMetadata={this.initialiseVideo}
          updateCurrentFrame={this.updateCurrentFrame}
          getDimensionsChild={this.getDimensionsChild}
          muted={this.props.muted}
          useInView={this.props.useInView}
          src={this.props.videoSrc}
          poster={this.props.poster}
          showSoundIcon
          loop={this.props.loopVideo} />
          {scrollToSlug && (
            <div style={{
              position: 'absolute',
              right: 0,
              bottom: 0,
              padding: '30px',
            }}>
              <RoundIconButton
                iconId="arrow-down"
                onClick={() => scrollToElementId(scrollToSlug)} />
            </div>
          )}
      </div>
    )
  }
}
VideoWithTimedFrames.defaultProps = {
  styles: {},
  frames: []
}

VideoWithTimedFrames.propTypes = {
  styles: PropTypes.object,
  videoSrc: PropTypes.string.isRequired,
  loopVideo: PropTypes.bool,
  scrollToSlug: PropTypes.string,
  muted: PropTypes.bool,
  frames: PropTypes.arrayOf(PropTypes.shape({
    time: PropTypes.number,
    components: PropTypes.node
  }))
}

export default Radium(VideoWithTimedFrames)



// WEBPACK FOOTER //
// ./src/components/video-with-timed-frames/index.jsx